import { render, staticRenderFns } from "./add.vue?vue&type=template&id=dfdd1996&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=dfdd1996&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdd1996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfdd1996')) {
      api.createRecord('dfdd1996', component.options)
    } else {
      api.reload('dfdd1996', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=dfdd1996&scoped=true", function () {
      api.rerender('dfdd1996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/enterpriseDistribution/companyManage/components/add.vue"
export default component.exports